import Users from './UsersController';

export default Users;
